const STORAGE_MUTED_KEY = 'ies.iot.breachSoundMuted';

/** @returns Whether breach beep is muted via `localStorage`. */
export function isIotBreachSoundMuted(): boolean {
  try {
    return localStorage.getItem(STORAGE_MUTED_KEY) === '1';
  } catch {
    return false;
  }
}

/** Persist mute preference for future breach notifications. */
export function setIotBreachSoundMuted(muted: boolean): void {
  try {
    if (muted) localStorage.setItem(STORAGE_MUTED_KEY, '1');
    else localStorage.removeItem(STORAGE_MUTED_KEY);
  } catch {
    /* ignore */
  }
}

/** Short sine beep via Web Audio API (no asset file). */
export function playIotThresholdBreachBeep(): void {
  try {
    const AC =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = 880;
    osc.type = 'sine';
    const t0 = ctx.currentTime;
    gain.gain.setValueAtTime(0.08, t0);
    gain.gain.exponentialRampToValueAtTime(0.01, t0 + 0.12);
    osc.start(t0);
    osc.stop(t0 + 0.12);
    osc.onended = () => {
      void ctx.close();
    };
  } catch {
    /* ignore */
  }
}
